import { PaginatedColumn } from '../types/app';

export const TABLE_COLUMNS_NAME: PaginatedColumn[] = [
  {
    label: 'Nombre',
    key: 'value',
  },
  {
    label: 'Detalles',
    key: 'description',
    flex: 2,
    minWidth: 250,
  },
  {
    label: 'Slug',
    key: 'slug',
  },
  {
    label: 'Acciones',
    key: 'actions',
    minWidth: 120,
    maxWidth: 120,
    centered: true,
  },
];
